'use strict';

var data = new function () {
    this.scriptsToLoad = [];
    this.scriptsLoaded = [];
    this.cssToLoad = [];
    this.cssLoaded = []; // Started to load
    this.cssLoadedFully = []; // Has rendered to DOM
    this.debug = false;

    this.doInitialiseSlickCarousels = function () {
        $('[data-slick]:not(.slick-initialized)').each(function () {
            if (data.isVisible($(this))) {
                var init = jQuery().slick;
                if (init) {
                    if ($(this).data('slickOptions')) {
                        var options = {};
                        if (typeof slickOptions == 'undefined') {
                            init = false;
                            setTimeout(function () {
                                data.doInitialiseSlickCarousels();
                            }, 100);
                        } else {
                            options = window['slickOptions'][$(this).data('slickOptions')]($(this));
                        }
                    }
                }
                if (init) {
                    $(this)
                        .on('init', function(event, slick) {
                            richerfilms.setSlickInit($(this), event, slick);
                        })
                        .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                            richerfilms.setSlickBeforeChange($(this), event, slick, currentSlide, nextSlide);
                        })
                        .on('afterChange', function(event, slick, currentSlide, nextSlide) {
                        })
                        .slick(options);
                }
            }
        });
    };
    this.doLoadScripts = function () {
        if (this.scriptsToLoad.length) {
            var scriptFileName = this.scriptsToLoad[0];
            data.scriptsToLoad.splice(0, 1);
            $.getScript(scriptFileName).done(function(scriptContents, textStatus) {
                if (typeof scriptContents != 'undefined' && !scriptContents.length) {
                    data.error('Loaded empty or invalid script', scriptFileName);
                }
                data.scriptsLoaded.push(scriptFileName);
                if (scriptFileName.indexOf('/js/vendor/slick.min.js') != -1) {
                    data.doInitialiseSlickCarousels();
                }
                if (scriptFileName.indexOf('zoom.min') != -1) {
                    $('.product__image-gallery-link').eq(0).trigger('mouseover'); // For the caption to work on first load
                }
                setTimeout(function () {
                    data.doLoadScripts();
                }, 10);
            })
            .fail(function () {
                data.error('Failed to load', scriptFileName);
                data.scriptsLoaded.push(scriptFileName);
                data.doLoadScripts();
            });
        }
    };
    this.getSlick = function (callObject, callMethod) {
        window[callObject][callMethod]();
    };
    this.do = function (event, el, prevent_default) {
        if (prevent_default) {
            if (!$(el).is(':checkbox')) {
                event.preventDefault();
            }
        }
        if (typeof $(el).data(event.type) != 'undefined') {
            var action = $(el).data(event.type);
            if (!$(el).hasClass('disabled') && !$(el).prop('disabled')) {
                if (typeof action != 'undefined') {
                    if (action.indexOf(':') != -1) {
                        var objectName = action.split(':')[0];
                        action = action.split(':')[1];
                        if (typeof window[objectName] == 'undefined') {
                            data.error(objectName + ' is undefined');
                        } else if (typeof window[objectName][action] == 'undefined') {
                            data.error(objectName + ' has no function ' + action);
                        } else {
                            window[objectName][action](event, el);
                        }
                    }
                }
            }
        }
    };
    this.error = function (message, obj) {
        if (data.debug) {
            console.error(message, obj);
        }
    }
    this.isVisible = function ($element, threshold) {
        if (typeof threshold == 'undefined') threshold = 20;
        var docViewBottom = $(window).scrollTop() + $(window).height(),
            elemTop = $element.offset().top;
        if (elemTop > 0 && elemTop > threshold) {
            elemTop -= threshold;
        }
        if ($element.closest('.slick-slide').length && !$element.closest('.slick-slide').hasClass('slick-active')) {
            return false;
        }
        return elemTop > 0 && elemTop <= docViewBottom;
    };
};
$(function() {
    var types = {click: true, mouseover: true, change: true, keydown: false, keyup: false, submit: true};
    $.each(types, function (type, automaticallyPreventDefault) {
        $(document).on(type, '[data-' + type + ']', function (e) {
            if (!$(this).prop('disabled') && !$(this).attr('disabled')) {
                data.do(e, this, automaticallyPreventDefault);
            }
        });
    });
    $(document).on('click', 'a[rel*=external]', function(e) { e.preventDefault(); window.open($(this).attr('href')); });
});
